export interface Rect { minX: number; maxX: number; minZ: number; maxZ: number }
export const rect = (cx: number, cz: number, w: number, d: number): Rect => ({ minX: cx - w / 2, maxX: cx + w / 2, minZ: cz - d / 2, maxZ: cz + d / 2 });
export const distToRect = (x: number, z: number, b: Rect): number => {
  const dx = Math.max(b.minX - x, 0, x - b.maxX), dz = Math.max(b.minZ - z, 0, z - b.maxZ);
  return Math.hypot(dx, dz);
};
export const inRect = (x: number, z: number, b: Rect, r = 0): boolean => x > b.minX - r && x < b.maxX + r && z > b.minZ - r && z < b.maxZ + r;
